import React, { type MouseEvent, forwardRef } from 'react';
import noop from 'lodash/noop';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { IconButton } from '@atlaskit/button/new';
import AddIcon from '@atlaskit/icon/core/add';

type Props = {
	label: string;
	onClick?: (e: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
};

const SquareAddIconButton = forwardRef<HTMLButtonElement, Props>((props, ref) => {
	const { label, onClick } = props;
	return (
		<div>
			<IconButton
				testId={`issue-view-common-views.button.icon-button.${label}`}
				appearance="subtle"
				spacing="compact"
				icon={(iconProps) => <AddIcon {...iconProps} color="currentColor" />}
				label={label}
				onClick={onClick}
				interactionName="auto-generated.jira-issue-view-common-views.button.button"
				ref={ref}
			/>
		</div>
	);
});

SquareAddIconButton.defaultProps = {
	onClick: noop,
};

export default SquareAddIconButton;
